import React from 'react';
import { motion } from 'framer-motion';
import { HeroFrame } from '../../../types/content';
import { pad2 } from '../../../utils/format';
interface HeroRulerProps {
  frames: HeroFrame[];
  index: number;
  onSelect: (i: number) => void;
  autoplay: boolean;
  duration: number;
}
export function HeroRuler({
  frames,
  index,
  onSelect,
  autoplay,
  duration
}: HeroRulerProps) {
  return <div className="bg-night text-white" data-id="element-187" data-mp="sqjvmo1dn3q7">
      <div className="shell grid grid-cols-4" data-id="element-188" data-mp="sopd1gdkvnpa">
        {frames.map((frame, i) => {
        const active = i === index;
        return <button key={frame.id} type="button" onClick={() => onSelect(i)} aria-label={`Afficher la séquence : ${frame.process}`} aria-current={active} className="group relative flex h-[72px] flex-col justify-between pt-3 text-left focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-ember" data-id="element-189" data-mp="is43chqm5of4" data-mpi={i}>
              <span className={`whitespace-nowrap font-mono text-[11px] uppercase tracking-wider transition-colors duration-150 ${active ? 'text-white' : 'text-white/45 group-hover:text-white/80'}`} data-id="element-190" data-mp="1oquy2ob75jmo">
                <span className="text-ember" data-id="element-191" data-mp="1tr927v9og9ff">{pad2(i + 1)}</span>
                <span className="ml-2 hidden sm:inline" data-id="element-192" data-mp="1towibckczozq">{frame.process}</span>
              </span>
              <svg className="h-6 w-full" aria-hidden data-id="element-193" data-mp="15zc04vw14vri">
                <defs data-id="element-194" data-mp="113d54pg74fi4">
                  <pattern id={`ticks-${frame.id}`} width="7" height="24" patternUnits="userSpaceOnUse" data-id="element-195" data-mp="113wq6f157k0d">
                    <line x1="0.5" y1="6" x2="0.5" y2="24" stroke="currentColor" strokeWidth="1" data-id="element-196" data-mp="1fsj184jqlpls" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill={`url(#ticks-${frame.id})`} className={`transition-colors duration-150 ${active ? 'text-white/50' : 'text-white/15 group-hover:text-white/30'}`} data-id="element-197" data-mp="nadqepo8mpbm" />
              </svg>
              <span className="absolute bottom-0 left-0 h-[2px] w-full bg-white/10" data-id="element-198" data-mp="2ncda0om7uioc" />
              {active && <motion.span key={`${frame.id}-${autoplay}`} className="absolute bottom-0 left-0 h-[2px] w-full origin-left bg-ember" initial={{
            scaleX: autoplay ? 0 : 1
          }} animate={{
            scaleX: 1
          }} transition={{
            duration: autoplay ? duration / 1000 : 0,
            ease: 'linear'
          }} data-id="element-199" data-mp="2s4y1vklkalp8" />}
            </button>;
      })}
      </div>
    </div>;
}